<template>
  <div>
    <header class="header-authenticate">
      <div class="container">
        <div class="header-authenticate__logo">
          <img src="@/assets/superliga/logo-1x.png" alt="" v-if="$config.MODE == 'SUPERLIGA'">
          <img src="@/assets/isologo.svg" alt="" v-else>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="home home--games">
        <div v-if="publishedGamesAnon.length == 0" class="home__empty-message">
          {{$t('home.message')}}
        </div>
        <div v-if="publishedGamesAnon.length > 0" class="home--games__list">
          <template v-for="(game, idxGame) in publishedGamesAnon">
            <card-game-anon :game="game" :key="`game-${idxGame}`" />
          </template>          
        </div>
      </div>
    </div>
    <footer-sponsor></footer-sponsor>
  </div>
</template>

<script>
import CardGameAnon from '@/components/Game/CardGameAnon.vue'
import FooterSponsor from '@/components/Footer/Sponsor.vue'
import { mapState } from 'vuex'

export default { 
  components: {
    CardGameAnon,
    FooterSponsor
  },
  computed: {
    ...mapState({
      publishedGamesAnon: state => state.InfoModule.publishedGamesAnon,
    })
  },
  created() {
    this.$store.dispatch('getPublishedGamesAnon')
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.home__empty-message {
  padding: $margin-base;
  border-radius: $redondeado;
  text-align: center;
  color: $white;
  font-size: $margin-base;
  width: 100%;
  background: $violet;
  margin: $margin-base 0;
}

</style>